<template>
    <div id="forward-document-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="forward-document-title" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="forward-document-title">Forward Document</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <span class="font-weight-bold">Forward To:</span>
                    <div class="d-flex flex-row">
                        <div class="flex-grow-1 mr-1">
                            <input type="text" class="form-control form-control-sm" list="contact-options" Placeholder="Name" :value="entry.name" @input="onInput($event.target.value)" />
                            <datalist id="contact-options">
                                <option v-for="contact in contacts" :key="contact.id" :value="contact.full_name" v-text="contact.full_name"></option>
                            </datalist>
                        </div>
                        <div class="mr-1">
                            <telephone-input v-if="method === TransmissionMethod.FAX" class="form-control form-control-sm" placeholder="Fax Number" v-model="entry.destination"></telephone-input>
                            <input v-else type="email" class="form-control form-control-sm" placeholder="Email Address" v-model="entry.destination">
                        </div>
                        <div>
                            <button type="button" class="btn btn-primary btn-sm" @click="add()" :disabled="!entry.destination">Add</button>
                        </div>
                    </div>
                    <div class="mt-1 pl-1"> 
                        <div v-for="e in destinations" class="d-flex flex-row" :key="'forward-transmission-' + e.destination">
                            <div class="pr-1">
                                <a href="javascript:void(0)" class="btn btn-link p-0 remove-button" title="Remove" @click="remove(e.destination)">
                                    <i class="fas fa-minus-circle fa-xs"></i>
                                </a>                                    
                            </div>                                
                            <div class="flex-fill text-truncate pr-1" :title="e.name">{{ e.name }}</div>
                            <div v-if="method === TransmissionMethod.FAX" class="text-nowrap">{{ e.destination | telephone }}</div>
                            <div v-else class="text-nowrap">{{ e.destination }}</div>
                        </div>
                    </div>
                    <div v-if="document" class="mt-2">
                        <span class="font-weight-bold">Document:</span>
                        <div class="text-truncate pl-3" :title="document.document_type.name + ' - ' + document.description">
                            {{ document.document_type.name }} - {{ document.description }}
                        </div>
                    </div>                    
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" :disabled="!destinations.length" @click="forward()">Send</button> 
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>    
                </div>                
            </div>
        </div>
    </div>     
</template>

<script>
import { TransmissionMethod } from '../../constants.js';

export default {
    props: {
        contacts: Array
    },
    data() {
        return {
            TransmissionMethod: TransmissionMethod,

            method: null,
            document: null,
            entry: {
                name: null,
                destination: null
            },            
            destinations: []
        }
    },
    methods: {
        show: function (method, document) {
            this.method = method;
            this.document = document;
            this.entry = {
                name: null,
                destination: null
            };
            this.destinations = [];
            $('#forward-document-modal').modal('show');
        },
        onInput: function (value) {

            let contact = this.contacts.find( (o) => { return o.full_name.toUpperCase() === value.toUpperCase(); });
            if (contact) {
                this.entry.name = contact.full_name;
                this.entry.destination = (this.method === TransmissionMethod.FAX) ? contact.fax : contact.email;
            }
            else {
                this.entry.name = value;
            }
        },
        add: function () {
            this.destinations.push(this.entry);
            this.entry = {
                name: null,
                destination: null
            };
        },
        remove: function (destination) {
            this.destinations = this.destinations.filter(e => e.destination !== destination);
        },
        forward: function () {
            let url = '/ajax/documents/' + this.document.id + '/fax-forward';
            if (this.method === TransmissionMethod.EMAIL) {
                url = '/ajax/documents/' + this.document.id + '/email-forward';
            }

            axios.post(url, {
                transmission_method_id: this.method,
                destinations: this.destinations  
            })
            .then(response => {
                $('#forward-document-modal').modal('hide');
            })
            .catch(error => {
                console.log(error);
                $('#forward-document-modal').modal('hide');
            });
        }      
    },  
    created() {
        eventHub.$on('show-forward-document', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-forward-document');
    }
}
</script>

<style scoped>
    .remove-button {
        position: relative;
        top: -5px;
    }
</style>